import { ThemeIcon } from "@mantine/core";
import { CSSProperties } from "react";
import RawSubjectIcon from "./RawSubjectIcon";

export default function SubjectIcon({
  className,
  subjectColorIndex,
  size = "md",
  style,
}: {
  className?: string;
  subjectColorIndex: string;
  size?: "sm" | "md" | "lg" | number;
  style?: CSSProperties;
}) {
  return (
    <ThemeIcon
      className={className}
      color={subjectColorIndex}
      size={size}
      style={style}
    >
      <RawSubjectIcon subjectColorIndex={subjectColorIndex} size={"80%"} />
    </ThemeIcon>
  );
}
